import { useEffect, useState } from "react";

// ui
import { Box, IconButton, Alert } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CircleIcon from "@mui/icons-material/Circle";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { PostCSVModal } from "../component/PostCSVModal";
import { GetXLSXTossUpModal } from "../component/GetXLSXTossUpModal";
import { TossUpAddModal } from "../component/TossUpAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { ClosingTossUpModal } from "../component/tableFunction/ClosingTossUpModal";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";
import { ContractCopyTossUpModal } from "../component/tableFunction/ContractCopyTossUpModal";
import { ChangeAccountCollaborateModal } from "../component/tableFunction/ChangeAccountCollaborateModal";
import { ColumnSettingModal } from "../component/ColumnSettingModal";

// jotai
import { useSetAtom, useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getTossUps,
  getTossUp,
  postTossUp,
  putTossUp,
  deleteTossUp,
  getTossUpAddBefore,
  getTossUpClosingBefore,
  putTossUpClosingFailed,
  putTossUpClosingCancell,
  getTossUpCopyBefore,
} from "../api/tossUp";
import { getOldTossUp } from "../api/oldTossUp";
import { postContract, postContractShortMessage } from "../api/contract";
import { getTossUpCategorys } from "../api/tossUpCategory";
import { getTossUpProducts } from "../api/tossUpProduct";
import { getTossUpCustomerInfos } from "../api/tossUpCustomerInfo";
import { getTossUpTossUpInfos, deleteTossUpTossUpInfo } from "../api/tossUpTossUpInfo";
import {
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
  getSerchSaleCompanyGroups,
  getSerchAccountSales,
  getSerchAccountCollaborateCompanys,
  getProductCandidatesTossUp,
} from "../api/serch";
import {
  getPresignedPostCSV,
  postPresignedPost,
  getPresignedPostPicture,
} from "../api/presignedURL";
import {
  getScreenColumns,
  getScreenColumnTossUps,
  putScreenColumnTossUps,
} from "../api/screenColumn";

// InterFace
import { tossUpTableColumn } from "../config/tossUp";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

// 一括トスアップ（パートナー・営業アカウント）
const postCSVColumnTossUp = [
  "トスアップアカウント氏名",
  "カテゴリー1",
  "、",
  "カテゴリー5",
  "商材名1",
  "、",
  "商材名10",
  "リストID",
  "架電希望日",
  "架電希望時間",
  "カテゴリによる質問",
];
const postCSVColumnTossUpResult = [
  "トスアップアカウント氏名",
  "リストID",
  "架電希望日",
  "架電希望時間",
];

// 一括トスアップ（マスター・スタッフアカウント）
const postCSVColumnTossUpAdmin = [
  "ステータス",
  "トスアップパートナー",
  "トスアップアカウント氏名",
  "カテゴリー1",
  "、",
  "カテゴリー5",
  "商材名1",
  "、",
  "商材名10",
  "リストID",
  "トスアップ日時",
  "架電・クロージング日時",
  "架電希望日",
  "架電希望時間",
  "クロージングパートナー",
  "クロージング担当者",
  "クロージング商材",
  "クロージング備考",
  "クロージング失敗理由",
  "架電備考",
  "顧客電話番号",
  "顧客氏名",
  "カテゴリによる質問",
];
const postCSVColumnTossUpResultAdmin = [
  "ステータス",
  "トスアップパートナー",
  "トスアップアカウント氏名",
  "リストID",
  "トスアップ日時",
  "架電・クロージング日時",
  "架電希望日",
  "架電希望時間",
  "クロージングパートナー",
  "クロージング担当者",
  "クロージング商材",
  "クロージング備考",
  "クロージング失敗理由",
  "架電備考",
  "顧客電話番号",
  "顧客氏名",
];
function TossUp() {
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const tossUpScreenColumn = useAtomValue(AppAtoms.tossUpScreenColumn);
  const setContractScreenColumn = useSetAtom(AppAtoms.contractScreenColumn);
  const setTossUpScreenColumn = useSetAtom(AppAtoms.tossUpScreenColumn);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    { auth: ["パートナー", "営業アカウント"], name: "トスアップ" },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "トスアップ一括CSV取込",
    },
    {
      auth: ["パートナー", "営業アカウント"],
      name: "CSV一括トスアップ",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      name: "トスアップ一覧出力",
    },
  ];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "トスアップ") {
      setAddData({
        ...addData,
        addStatus: "change_account",
      });
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "トスアップ一括CSV取込") {
      setPostTossUpCSVAdminStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "CSV一括トスアップ") {
      setPostTossUpCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  useEffect(() => {
    if (getXLSXDataName === "トスアップ一覧出力") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "open",
      });
    }
  }, [getXLSXDataName]);

  useEffect(() => {}, [editDatasName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "カテゴリー一覧") {
      getSubtableDataTossUpCategory();
    }
    if (getSubTableName.name === "商材一覧") {
      getSubtableDataTossUpProduct();
    }
    if (getSubTableName.name === "顧客情報一覧") {
      getSubtableDataTossUpCustomerInfo();
    }
    if (getSubTableName.name === "トスアップ情報一覧") {
      getSubtableDataTossUpTossUpInfo();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
    subTableColumnName?: string;
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "クロージング") {
      setClosingData((closingData) => ({
        ...closingData,
        addStatus: "change_account",
      }));
    }
    if (tableOriginalFunc.name === "トスアップ複製") {
      setCopyDataInf({
        ...copyDataInf,
        addStatus: "change_account",
      });
    }
    if (tableOriginalFunc.name === "トスアップ取消") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "トスアップ情報一覧"
    ) {
      setDeleteTossUpInfoDataInf({
        status: "open",
        key: { infoKey: tableOriginalFunc.key.toss_up_key },
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key, tableOriginalFunc.subTableColumnName]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);
  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();
  const [firstLoading, setFirstLoading] = useState(true);

  // カラムデータの設定
  const [columnSetting, setColumnSetting] = useState<{
    status: "none" | "open" | "loading" | "result" | "error";
    columns: {
      id: number;
      screen_column_auth: 0 | 1;
      screen_column_system_default: 0 | 1;
      table_disabled: 0 | 1;
      screen_column_serch_disabled: 0 | 1;
      detail_disabled: 0 | 1;
      screen_column_name: string;
      screen_column_type: 0 | 1 | 2;
      table_sort: 0 | 1;
      screen_column_table: 0 | 1;
      table_column_size: string;
      screen_column_sort_id: number;
      screen_column_serch: 0 | 1;
      screen_column_detail: 0 | 1;
    }[];
  }>({
    status: "none",
    columns: [],
  });
  useEffect(() => {
    if (columnSetting.status === "loading") {
      setIsLoading(true);
    } else if (columnSetting.status !== "none") {
      setIsLoading(false);
    }
  }, [columnSetting]);

  async function openColumnSettingWindow() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    // 既存カラムの取得
    const { fetch_data } = await getScreenColumnTossUps();
    setColumnSetting({
      status: "open",
      columns: fetch_data,
    });
  }

  async function putClumnSetting() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    const res = await putScreenColumnTossUps(columnSetting.columns);
    if (res === "success") {
      setChangeTableData(false);
      setColumnLoading(true);
      await getTableData(true);
      const { contractScreenColumn, tossUpScreenColumn } =
        await getScreenColumns();
      setContractScreenColumn(contractScreenColumn);
      setTossUpScreenColumn(tossUpScreenColumn);
      setColumnSetting({
        ...columnSetting,
        status: "result",
      });
    } else {
      setColumnSetting({
        ...columnSetting,
        status: "error",
      });
    }
  }

  function closeColumnSettingModal() {
    setColumnSetting({
      status: "none",
      columns: [],
    });
  }

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | string[] };
  } | null>(null);

  // 検索項目
  const [serchColumn, setSerchColumn] = useState<{ [key: string]: string }>({});
  const [serchString, setSerchString] = useState<{ [key: string]: string }>({});
  const [serchStringView, setSerchStringView] = useState<{
    [key: string]: string;
  }>({});

  // ソート項目
  const [sortColumn, setSortColumn] = useState<
    {
      key: string;
      sort: string;
    }[]
  >([]);

  // 項目データ読み込み中フラグ
  const [columnLoading, setColumnLoading] = useState(true);

  useEffect(() => {
    if (tossUpScreenColumn.length > 0) {
      // 検索項目
      const serchColumn = tossUpScreenColumn.reduce((column, difine) => {
        if (difine.serch === true) {
          if (difine.serchType === "date") {
            return {
              ...column,
              [difine.key + "_start"]: "",
              [difine.key + "_end"]: "",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      }, {});
      setSerchColumn(serchColumn);
      setSerchString(serchColumn);
      setSerchStringView(serchColumn);

      // ソート項目
      const sortColumn = tossUpScreenColumn
        .filter((column) => {
          return column.sort;
        })
        .map((column) => {
          return {
            key: column.key,
            sort: "DESC",
          };
        })
        .sort((a, b) => {
          if (a.key === "hope_call_date") return -1;
          if (b.key === "hope_call_date") return 1;
          return 0;
        });
      setSortColumn(sortColumn);
      setColumnLoading(false);
    }
  }, [tossUpScreenColumn]);

  // トスアップ登録
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addData, setAddData] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    category_id_list: [],
    product_name_list: [],
    phone_number: "",
    customer_name: "",
    customer_list_id: "",
    hope_call_date: "",
    hope_call_time_kind: null,
    hope_call_time: "12-00",
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  useEffect(() => {
    if (addData.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [addData]);
  const [tossUpCategoryNameList, setTossUpCategoryNameList] = useState<
    {
      category_id: number;
      category_name: string;
    }[]
  >([]);
  const [tossUpProductNameList, setTossUpProductNameList] = useState<
    {
      category_id: number;
      category_name: string;
      product_name: string;
    }[]
  >([]);
  async function getTossUpProductList() {
    setAddData({
      ...addData,
      addStatus: "loading",
    });
    const { tossUpCategoryNameList, tossUpProductNameList } =
      await getTossUpAddBefore(addData.changeAccount, addData.changeAccountID);
    if (tossUpCategoryNameList.length > 0) {
      setTossUpCategoryNameList(tossUpCategoryNameList);
      setTossUpProductNameList(tossUpProductNameList);
      // 製品選択画面に移行
      setAddData({
        ...addData,
        addStatus: "product",
      });
    } else {
      closeAddModal();
      setOnDataAddModalResult(
        "トスアップ可能な商材が定義されていません。管理者に問い合わせてください。",
      );
    }
  }
  // 画像データ保持用
  const [postPictures, setPostPicture] = useState<{
    [key: string]: File;
  }>({});
  const [uniqueOptinList, setUniqueOptinList] = useState<
    { [key: string]: string | number | string[] }[]
  >([]);
  const [addressOptionName, setAddressOptionName] = useState("");

  function closeAddModal() {
    setAddData({
      addStatus: null,
      category_id_list: [],
      product_name_list: [],
      phone_number: "",
      customer_name: "",
      customer_list_id: "",
      hope_call_date: "",
      hope_call_time_kind: null,
      hope_call_time: "12-00",
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setTossUpCategoryNameList([]);
    setTossUpProductNameList([]);
    setPostPicture({});
    setUniqueOptinList([]);
    setAddressOptionName("");
  }
  async function postAddData(customerInfo: {
    [key: string]: string | string[];
  }) {
    const postResponce = await postTossUp({ ...addData, customerInfo });
    if (postResponce === "success") {
      await getTableData(true);
      getProductNameLists();
      closeAddModal();
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModalResult(postResponce);
      setAddData({
        ...addData,
        addStatus: "toss_up",
      });
    }
  }

  // クロージング処理用
  const [closingData, setClosingData] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "open"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "copyTossUp"
      | "sms_success";
    key: { [key: string]: string };
    toss_up_status: number | null;
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    closing_memo: string;
    closing_failed_memo: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    return_call_memo: string;
    copy_toss_up: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    key: {},
    toss_up_status: null,
    outSiteEntry: 0,
    outsideSiteUrl: "",
    outsideServiceUrl: "",
    viewOutsideServiceUrl: 0,
    closing_memo: "",
    closing_failed_memo: "",
    hope_call_date: "",
    hope_call_time_kind: null,
    hope_call_time: "12-00",
    return_call_memo: "",
    copy_toss_up: 0,
    productId: null,
    productName: "",
    have_entry_form: null,
    site_path_list: [],
    site_path: "",
    outsideMessageType: null,
    phone_number: "",
    customer_name: "",
    customer_company_name: "",
    servicePlanName: "",
    serviceContentNameList: [],
    serviceCampaignPulldownName: "",
    serviceCampaignCheckboxName: [],
    servicePaymentMethodName: "",
    serviseCustomerListID: "",
    pullDownServiceName: "",
    checkBoxServiceNames: "",
    smsMessagePatternID: null,
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  useEffect(() => {
    if (closingData.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [closingData]);

  // データ詳細（クロージングウィンドウ）
  const [dataDetailClosing, setDataDetailClosing] = useState<{
    [key: string]: number | string | { [key: string]: string | string[] };
  } | null>(null);
  const [dataDetailOptionClosing, setDataDetailOptionClosing] = useState<
    { [key: string]: string | number }[]
  >([]);

  // クロージング処理開始
  async function startClosing() {
    setClosingData((closingData) => ({
      ...closingData,
      addStatus: "loading",
      key: tableOriginalFunc.key,
    }));
    const { toss_up_data, product_data, detail_data, option_data } =
      await getTossUpClosingBefore(
        tableOriginalFunc.key.id,
        closingData.changeAccount,
        closingData.changeAccountID,
      );
    setClosingProductList(product_data);
    setDataDetailClosing(detail_data);
    setDataDetailOptionClosing(option_data);
    setClosingData((closingData) => ({
      ...closingData,
      addStatus: "open",
      key: tableOriginalFunc.key,
      toss_up_status: toss_up_data.toss_up_status as number,
      phone_number: toss_up_data.customer_phone_number as string,
      customer_name: toss_up_data.customer_name as string,
      closing_memo: toss_up_data.closing_memo as string,
      closing_failed_memo: toss_up_data.closing_failed_memo as string,
      hope_call_date: toss_up_data.hope_call_date as string,
      hope_call_time_kind: toss_up_data.hope_call_time_kind as number,
      hope_call_time: toss_up_data.hope_call_time as string,
      return_call_memo: toss_up_data.return_call_memo as string,
      serviseCustomerListID: toss_up_data.customer_list_id as string,
      customerInfo: toss_up_data.customer_info as {
        [key: string]: string | string[];
      },
    }));
    getTableData(true);
  }
  // クロージングウィンドウの各種情報一覧
  const [closingProductList, setClosingProductList] = useState<
    {
      id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[]
  >([]);
  const [selectServisePlanList, setSelectServisePlanList] = useState<
    { service_name: string }[]
  >([]);
  const [selectServiseContentList, setSelectServiseContentList] = useState<
    { service_name: string }[]
  >([]);
  const [
    selectServiseCampaignPulldownList,
    setSelectServiseCampaignPulldownList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    selectServiseCampaignCheckboxList,
    setSelectServiseCampaignCheckboxList,
  ] = useState<{ service_name: string }[]>([]);
  const [selectServisePaymentList, setSelectServisePaymentList] = useState<
    { payment_method: string }[]
  >([]);
  const [closingUniqueOptinList, setClosingUniqueOptinList] = useState<
    { [key: string]: string | number | string[] }[]
  >([]);
  const [closingAddressOptionName, setClosingAddressOptionName] = useState("");
  const [closingPostPictures, setClosingPostPicture] = useState<{
    [key: string]: File;
  }>({});
  async function closeClosingModal() {
    setClosingData((closeingTossUpInf) => ({
      ...closeingTossUpInf,
      addStatus: "loading",
    }));
    setClosingData({
      addStatus: null,
      key: {},
      toss_up_status: null,
      outSiteEntry: 0,
      outsideSiteUrl: "",
      outsideServiceUrl: "",
      viewOutsideServiceUrl: 0,
      closing_memo: "",
      closing_failed_memo: "",
      hope_call_date: "",
      hope_call_time_kind: null,
      hope_call_time: "12-00",
      return_call_memo: "",
      copy_toss_up: 0,
      productId: null,
      productName: "",
      have_entry_form: null,
      site_path_list: [],
      site_path: "",
      outsideMessageType: null,
      phone_number: "",
      customer_name: "",
      customer_company_name: "",
      servicePlanName: "",
      serviceContentNameList: [],
      serviceCampaignPulldownName: "",
      serviceCampaignCheckboxName: [],
      servicePaymentMethodName: "",
      serviseCustomerListID: "",
      pullDownServiceName: "",
      checkBoxServiceNames: "",
      smsMessagePatternID: null,
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setDataDetailClosing(null);
    setDataDetailOptionClosing([]);
    setClosingProductList([]);
    setSelectServisePlanList([]);
    setSelectServiseContentList([]);
    setSelectServiseCampaignPulldownList([]);
    setSelectServiseCampaignCheckboxList([]);
    setSelectServisePaymentList([]);
    setClosingUniqueOptinList([]);
    setClosingAddressOptionName("");
    setClosingPostPicture({});
  }

  // クロージングモーダルでの閉じる
  async function cancellClosingModal() {
    setClosingData((closeingTossUpInf) => ({
      ...closeingTossUpInf,
      addStatus: "loading",
    }));
    await putTossUpClosingCancell(closingData.key.id);
    await getTableData(true);
    setClosingData({
      addStatus: null,
      key: {},
      toss_up_status: null,
      outSiteEntry: 0,
      outsideSiteUrl: "",
      outsideServiceUrl: "",
      viewOutsideServiceUrl: 0,
      closing_memo: "",
      closing_failed_memo: "",
      hope_call_date: "",
      hope_call_time_kind: null,
      hope_call_time: "12-00",
      return_call_memo: "",
      copy_toss_up: 0,
      productId: null,
      productName: "",
      have_entry_form: null,
      site_path_list: [],
      site_path: "",
      outsideMessageType: null,
      phone_number: "",
      customer_name: "",
      customer_company_name: "",
      servicePlanName: "",
      serviceContentNameList: [],
      serviceCampaignPulldownName: "",
      serviceCampaignCheckboxName: [],
      servicePaymentMethodName: "",
      serviseCustomerListID: "",
      pullDownServiceName: "",
      checkBoxServiceNames: "",
      smsMessagePatternID: null,
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setClosingProductList([]);
    setSelectServisePlanList([]);
    setSelectServiseContentList([]);
    setSelectServiseCampaignPulldownList([]);
    setSelectServiseCampaignCheckboxList([]);
    setSelectServisePaymentList([]);
    setClosingUniqueOptinList([]);
    setClosingAddressOptionName("");
    setClosingPostPicture({});
  }
  const [onDataClosingModalResult, setOnDataClosingModalResult] = useState("");
  // クロージング処理 - 失敗・不出・折り返し
  async function putClosingFailed() {
    setClosingData((closeingTossUpInf) => ({
      ...closeingTossUpInf,
      addStatus: "loading",
    }));
    const putResponce = await putTossUpClosingFailed(
      closingData.key.id,
      closingData.toss_up_status as number,
      closingData.closing_memo,
      closingData.closing_failed_memo,
      closingData.hope_call_date,
      closingData.hope_call_time_kind,
      closingData.hope_call_time,
      closingData.return_call_memo,
      closingData.changeAccount,
      closingData.changeAccountID,
    );
    if (putResponce === "success") {
      await getTableData(true);
      closeClosingModal();
      setOnDataClosingModalResult("データの更新に成功しました。");
    } else {
      setOnDataClosingModalResult(putResponce);
      setClosingData((closingData) => ({
        ...closingData,
        addStatus: "open",
      }));
    }
  }
  function copyClosingTossUp() {
    setTableOriginalFunc({
      name: "トスアップ複製",
      key: {
        id: closingData.key.id,
      },
    });
    closeClosingModal();
  }
  async function closeingTossUpData(customerInfo: {
    [key: string]: string | string[];
  }) {
    if (closingData.outSiteEntry == 0) {
      const postResponce = await postContract({ ...closingData, customerInfo });
      if (postResponce === "success") {
        if (closingData.copy_toss_up === 1) {
          await getTableData(true);
          getProductNameLists();
          setClosingData((closingData) => ({
            ...closingData,
            addStatus: "copyTossUp",
          }));
        } else {
          await getTableData(true);
          getProductNameLists();
          closeClosingModal();
          setOnDataClosingModalResult("success");
        }
      } else {
        setOnDataClosingModalResult(postResponce);
        setClosingData({
          ...closingData,
          addStatus: "contract",
        });
      }
    } else if (closingData.outSiteEntry == 1) {
      let mail_address = "@";
      closingUniqueOptinList.map((uniqueOptin) => {
        if (uniqueOptin.mail_address_flg === 1) {
          mail_address = closingData.customerInfo[
            uniqueOptin.option_name as string
          ] as string;
        }
      });
      if (mail_address === "@" && closingData.customerInfo["メールアドレス"]) {
        mail_address = closingData.customerInfo["メールアドレス"] as string;
      }
      const toss_up_id = closingData.key.id;
      const closing_memo = closingData.closing_memo;
      const {
        postResponce,
        outsideSiteUrl,
        outsideServiceUrl,
        viewOutsideServiceUrl,
      } = await postContractShortMessage(
        {
          ...closingData,
          customerInfo,
        },
        mail_address,
        toss_up_id,
        closing_memo,
      );
      if (postResponce === "success") {
        setClosingData({
          ...closingData,
          addStatus: "sms_success",
          outsideSiteUrl,
          outsideServiceUrl,
          viewOutsideServiceUrl,
        });
      } else {
        setOnDataClosingModalResult(postResponce);
        setClosingData({
          ...closingData,
          addStatus: "contract",
        });
      }
    }
  }

  // データのトスアップへのコピー
  const [copyDataInf, setCopyDataInf] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    contract_id: string;
    toss_up_id: string;
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    contract_id: "",
    toss_up_id: "",
    category_id_list: [],
    product_name_list: [],
    phone_number: "",
    customer_name: "",
    customer_list_id: "",
    hope_call_date: "",
    hope_call_time_kind: null,
    hope_call_time: "12-00",
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  useEffect(() => {
    if (copyDataInf.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [copyDataInf]);
  // 画像データ保持用
  const [copyDataPostPictures, setCopyDataPostPicture] = useState<{
    [key: string]: File;
  }>({});
  const [copyDataUniqueOptinList, setCopyDataUniqueOptinList] = useState<
    { [key: string]: string | number | string[] }[]
  >([]);
  const [copyDataAddressOptionName, setCopyDataAddressOptionName] =
    useState("");
  async function openCopyData() {
    setCopyDataInf({
      ...copyDataInf,
      addStatus: "loading",
      toss_up_id: tableOriginalFunc.key.id as string,
    });
    const { tossUpCategoryNameList, tossUpProductNameList, toss_up_data } =
      await getTossUpCopyBefore(
        tableOriginalFunc.key.id,
        copyDataInf.changeAccount,
        copyDataInf.changeAccountID,
      );
    if (tossUpCategoryNameList.length > 0) {
      setTossUpCategoryNameList(tossUpCategoryNameList);
      setTossUpProductNameList(tossUpProductNameList);
      // 製品選択画面に移行
      setCopyDataInf({
        ...copyDataInf,
        addStatus: "product",
        toss_up_id: tableOriginalFunc.key.id as string,
        phone_number: toss_up_data.customer_phone_number as string,
        customer_name: toss_up_data.customer_name as string,
        customer_list_id: toss_up_data.customer_list_id as string,
        customerInfo: toss_up_data.customer_info as {
          [key: string]: string | string[];
        },
      });
    } else {
      closeCopyDataModal();
      setOnDataAddModalResult(
        "トスアップ可能な商材が定義されていません。管理者に問い合わせてください。",
      );
    }
  }
  function closeCopyDataModal() {
    setCopyDataInf({
      addStatus: null,
      contract_id: "",
      toss_up_id: "",
      category_id_list: [],
      product_name_list: [],
      phone_number: "",
      customer_name: "",
      customer_list_id: "",
      hope_call_date: "",
      hope_call_time_kind: null,
      hope_call_time: "12-00",
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setTossUpCategoryNameList([]);
    setTossUpProductNameList([]);
    setCopyDataPostPicture({});
    setCopyDataUniqueOptinList([]);
    setCopyDataAddressOptionName("");
  }
  async function postCopyDataData(customerInfo: {
    [key: string]: string | string[];
  }) {
    const postResponce = await postTossUp({ ...copyDataInf, customerInfo });
    if (postResponce === "success") {
      await getTableData(true);
      closeCopyDataModal();
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModalResult(postResponce);
      setCopyDataInf({
        ...copyDataInf,
        addStatus: "toss_up",
      });
    }
  }

  // トスアップ一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getTossUps(
      {
        ...serchString,
        displayNumber,
        pageNumber,
      },
      sortColumn,
      tossUpScreenColumn,
    );
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.tossUps);
      const countTossUps = Number(fetchData.countTossUps);
      setTotalCount(countTossUps);
      setMaxPageNumber(Math.ceil(countTossUps / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
    setFirstLoading(false);
  }
  // 初回データ取得
  useEffect(() => {
    if (firstLoading) {
      getTableData(false);
    }
  }, []);

  // テーブルデータの更新受付
  const [changeTableData, setChangeTableData] = useState(false);

  // 変更があったときのみ
  useEffect(() => {
    if (!firstLoading && changeTableData) {
      getTableData(false);
    } else if (columnLoading === false) {
      setChangeTableData(true);
    }
  }, [serchString, displayNumber, pageNumber, sortColumn]);

  // 商材表示用
  const [dataDetailOption, setDataDetailOption] = useState<
    { [key: string]: string | number }[]
  >([]);
  const [dataDetailHistory, setDataDetailHistory] = useState<
    { selected_date: string; contract_version: number }[]
  >([]);
  const [selectHistory, setSelectHistory] = useState<number>(0);

  // トスアップ詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const { detail_data, option_data, contract_history } = await getTossUp(id);
    if (detail_data) {
      setDataDetail(detail_data);
      setDataDetailOption(option_data);
      setDataDetailHistory(contract_history);
      setSelectHistory(detail_data.contract_version as number);
    } else {
      setDataDetail(null);
      setDataDetailOption([]);
      setDataDetailHistory([]);
      setSelectHistory(0);
    }
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 詳細（履歴）取得
  async function getOldDataDetail(
    id: string,
    service_plan_id: string,
    contract_version: number,
  ) {
    setIsLoading(true);
    setDataDetail(null);
    const last_contract_version = dataDetailHistory.reduce(
      (max, item) =>
        item.contract_version > max ? item.contract_version : max,
      dataDetailHistory[0].contract_version,
    );
    if (contract_version === last_contract_version) {
      await getDataDetail({ id }, true);
      setIsLoading(false);
      return;
    } else {
      const { detail_data } = await getOldTossUp(id, contract_version);
      setDataDetail(detail_data);
      setSelectHistory(contract_version);
      setIsLoading(false);
    }
  }
  // データ編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  const [selectTossUpInfo, setSelectTossUpInfo] = useState<{
    tossUpCategoryNameList: {
      category_id: number;
      category_name: string;
    }[];
    tossUpProductNameList: {
      category_id: number;
      category_name: string;
      product_name: string;
    }[];
  }>({
    tossUpCategoryNameList: [],
    tossUpProductNameList: [],
  });
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      const service_id = editData.service_id as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      if (editData.editType === "customer_picture") {
        if (
          editData.customer_picture &&
          typeof editData.editValue !== "string"
        ) {
          // 顧客情報の画像変更
          const editValue = editData.editValue as {
            [key: string]: string | string[];
          };
          let customer_info = { ...editValue };

          const fileName = editData.customer_picture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", editData.customer_picture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          customer_info[editData.key] = destination_key;
          const _EditData = {
            ...editData,
            editValue: customer_info,
          };
          const putResponce = await putTossUp(_EditData);
          await getDataDetail({ id, service_id }, true);
          await getTableData(true);
          await getSubtableDataTossUpCustomerInfo();
          setEditData({
            ..._EditData,
            status: putResponce,
          });
        }
      } else {
        const putResponce = await putTossUp(editData);
        await getDataDetail({ id, service_id }, true);
        await getTableData(true);
        await getSubtableDataTossUpCustomerInfo();
        setEditData({
          ...editData,
          status: putResponce,
        });
      }
      setIsLoading(false);
    }
  }

  // カテゴリー一覧取得
  async function getSubtableDataTossUpCategory() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpCategorys(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 商材一覧取得
  async function getSubtableDataTossUpProduct() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpProducts(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 顧客情報一覧取得
  async function getSubtableDataTossUpCustomerInfo() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const { sudDatas, option_data } = await getTossUpCustomerInfos(
        getSubTableName.key.id,
      );
      const fetchData = option_data.map((option) => {
        return {
          ...option,
          id: sudDatas[0]["toss_up_id"],
          product_id: sudDatas[0]["product_id"],
          customer_info: sudDatas[0]["customer_info"],
          customer_info_key: option.option_name,
          customer_info_value: sudDatas[0]["customer_info"][option.option_name],
        };
      });
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData,
      });
      setIsLoading(false);
    }
  }

  // トスアップ情報一覧取得
  async function getSubtableDataTossUpTossUpInfo() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpTossUpInfos(getSubTableName.key.id);
      const tossUpInfo = fetchData.sudDatas[0].toss_up_info as {
        [key: string]: string;
      };
      const tossUpInfoKeys = Object.keys(tossUpInfo);
      const subData = tossUpInfoKeys.map((key) => {
        return {
          toss_up_key: key,
          toss_up_value: tossUpInfo[key],
        };
      });
      setGetSubTableName({
        ...getSubTableName,
        subData,
      });
      setIsLoading(false);
    }
  }

  // トスアップ情報項目削除
  const [deleteTossUpInfoDataInf, setDeleteTossUpInfoDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteTossUpInfoData() {
    setDeleteTossUpInfoDataInf({
      ...deleteTossUpInfoDataInf,
      status: "loading",
    });
    const responce = await deleteTossUpTossUpInfo(
      getSubTableName.key.id,
      deleteTossUpInfoDataInf.key.infoKey
    );
    if (responce === "success") {
      await getTableData(false);
      await getSubtableDataTossUpTossUpInfo();
      setDeleteTossUpInfoDataInf({
        ...deleteTossUpInfoDataInf,
        status: "success",
      });
    } else {
      setDeleteTossUpInfoDataInf({
        ...deleteTossUpInfoDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteTossUpInfoDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteTossUpInfoDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteTossUpInfoDataInf]);

  // 顧客情報ダイレクト編集
  const [editDataCustomerInfo, setEditDataCustomerInfo] =
    useState<EditDataDifine | null>(null);
  async function putEditSubtableDataDirectCustomerInfo() {
    if (editDataCustomerInfo !== null) {
      setIsLoading(true);
      setEditDataCustomerInfo({
        ...editDataCustomerInfo,
        status: "editing",
      });

      if (editDataCustomerInfo.editType === "customer_picture") {
        if (
          editDataCustomerInfo.customer_picture &&
          typeof editDataCustomerInfo.editValue !== "string"
        ) {
          // 顧客情報の画像変更
          const editValue = editDataCustomerInfo.editValue as {
            [key: string]: string | string[];
          };
          let customer_info = { ...editValue };

          const fileName = editDataCustomerInfo.customer_picture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", editDataCustomerInfo.customer_picture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          customer_info[editDataCustomerInfo.key] = destination_key;
          const _editDataCustomerInfo = {
            ...editDataCustomerInfo,
            editValue: customer_info,
          };
          const putResponce = await putTossUp(_editDataCustomerInfo);
          await getTableData(true);
          await getSubtableDataTossUpCustomerInfo();
          setEditDataCustomerInfo({
            ..._editDataCustomerInfo,
            status: putResponce,
          });
        }
      } else {
        const putResponce = await putTossUp(editDataCustomerInfo);
        if (putResponce == "success") {
          await getTableData(true);
          await getSubtableDataTossUpCustomerInfo();
        }
        setEditDataCustomerInfo({
          ...editDataCustomerInfo,
          status: putResponce,
        });
      }
      setIsLoading(false);
    }
  }

  // データ無効化
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteTossUp(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  //契約一括エントリー
  const [postTossUpCSVStatus, setPostTossUpCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postTossUpCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postTossUpCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postTossUpCSVStatus]);
  async function postTossUpCSV(postDatas: File) {
    setPostTossUpCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostTossUpCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "tossUp";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostTossUpCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postTossUpCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostTossUpCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postTossUpCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostTossUpCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postTossUpCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostTossUpCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }
  // トスアップ一括CSV取込
  const [postTossUpCSVAdminStatus, setPostTossUpCSVAdminStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postTossUpCSVAdminStatus.status === "loading") {
      setIsLoading(true);
    } else if (postTossUpCSVAdminStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postTossUpCSVAdminStatus]);
  async function postTossUpCSVAdmin(postDatas: File) {
    setPostTossUpCSVAdminStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostTossUpCSVAdminStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "tossUpAdmin";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostTossUpCSVAdminStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postTossUpCSVAdminStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostTossUpCSVAdminStatus({
          status: "result",
          message: "CSV取込完了",
          result: postTossUpCSVAdminStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostTossUpCSVAdminStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postTossUpCSVAdminStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostTossUpCSVAdminStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }
  // トスアップ一覧エクセル出力
  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    toss_up_state: number[];
    all_toss_up_state: boolean;
    category_id_list: number[];
    all_category: boolean;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    toss_up_start_year: string;
    toss_up_start_month: string;
    toss_up_end_year: string;
    toss_up_end_month: string;
    toss_up_all_year: boolean;
    closing_start_year: string;
    closing_start_month: string;
    closing_end_year: string;
    closing_end_month: string;
    closing_all_year: boolean;
    hope_call_start_year: string;
    hope_call_start_month: string;
    hope_call_end_year: string;
    hope_call_end_month: string;
    hope_call_all_year: boolean;
  }>({
    status: "none",
    message: "",
    toss_up_state: [],
    all_toss_up_state: false,
    category_id_list: [],
    all_category: false,
    sale_company_id: null,
    sale_company_name: "",
    all_company: true,
    product_id: null,
    product_name: "",
    all_product: true,
    toss_up_start_year: lastYear.toString(),
    toss_up_start_month: lastMonth.toString(),
    toss_up_end_year: thisYear.toString(),
    toss_up_end_month: thisMonth.toString(),
    toss_up_all_year: false,
    closing_start_year: lastYear.toString(),
    closing_start_month: lastMonth.toString(),
    closing_end_year: thisYear.toString(),
    closing_end_month: thisMonth.toString(),
    closing_all_year: true,
    hope_call_start_year: lastYear.toString(),
    hope_call_start_month: lastMonth.toString(),
    hope_call_end_year: thisYear.toString(),
    hope_call_end_month: thisMonth.toString(),
    hope_call_all_year: true,
  });

  async function getTossUpsXLSX() {
    const idToken = loginUser?.idToken;
    const companyName = getXLSXStatus.all_company
      ? "全社"
      : getXLSXStatus.sale_company_name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const fileName =
      loginUser?.authority !== "パートナー" &&
      loginUser?.authority !== "営業アカウント"
        ? "【トスアップ一覧】トスアップパートナー:" +
          companyName +
          "_" +
          nowTimeName +
          ".xlsx"
        : "【トスアップ一覧】" + nowTimeName + ".xlsx";
    const bodys = {
      type: "get_xlsx_toss_up",
      sale_company_id: getXLSXStatus.sale_company_id,
      sale_company_name: getXLSXStatus.sale_company_name,
      toss_up_state: getXLSXStatus.toss_up_state,
      all_toss_up_state: getXLSXStatus.all_toss_up_state,
      category_id_list: getXLSXStatus.category_id_list,
      all_category: getXLSXStatus.all_category,
      all_company: getXLSXStatus.all_company,
      product_id: getXLSXStatus.product_id,
      product_name: getXLSXStatus.product_name,
      all_product: getXLSXStatus.all_product,
      toss_up_start_year: getXLSXStatus.toss_up_start_year,
      toss_up_start_month: getXLSXStatus.toss_up_start_month,
      toss_up_end_year: getXLSXStatus.toss_up_end_year,
      toss_up_end_month: getXLSXStatus.toss_up_end_month,
      toss_up_all_year: getXLSXStatus.toss_up_all_year,
      closing_start_year: getXLSXStatus.closing_start_year,
      closing_start_month: getXLSXStatus.closing_start_month,
      closing_end_year: getXLSXStatus.closing_end_year,
      closing_end_month: getXLSXStatus.closing_end_month,
      closing_all_year: getXLSXStatus.closing_all_year,
      hope_call_start_year: getXLSXStatus.hope_call_start_year,
      hope_call_start_month: getXLSXStatus.hope_call_start_month,
      hope_call_end_year: getXLSXStatus.hope_call_end_year,
      hope_call_end_month: getXLSXStatus.hope_call_end_month,
      hope_call_all_year: getXLSXStatus.hope_call_all_year,
      idToken,
      fileName,
    };
    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.outputXLSXTossUpsWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        const url = decodedData.url;
        const link = document.createElement("a");
        link.href = decodedData.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode?.removeChild(link);

        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "result",
          message: "トスアップ一覧出力完了",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "getting",
          message: decodedData.message,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }
  // 商材一覧
  const [productList, setProductList] = useState<
    {
      id: number;
      high_rank_company_id: number;
      product_name: string;
      high_rank_company_name: string;
    }[]
  >([]);
  const [productNameListCloser, setProductNameListCloser] = useState<string[]>([""]);
  const [productNameListTossUp, setProductNameListTossUp] = useState<string[]>([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
          high_rank_company_name: string;
        }[],
      );
    }
  }
  async function getProductNameLists() {
    const [closer, tossup] = await Promise.all([
      getProductCandidatesTossUp("closer"),
      getProductCandidatesTossUp(),
    ]);
    if (closer) {
      const names: string[] = [""];
      for (const p of closer) {
        if (p.product_name && !names.includes(p.product_name)) names.push(p.product_name);
      }
      setProductNameListCloser(names);
    }
    if (tossup) {
      const names: string[] = [""];
      for (const p of tossup) {
        if (p.product_name && !names.includes(p.product_name)) names.push(p.product_name);
      }
      setProductNameListTossUp(names);
    }
  }
  // グループ一覧取得
  const [searchGroupList, setSearchGroupList] = useState<
    {
      id: number;
      group_name: string;
      sale_company_id: number;
    }[]
  >([]);
  const [searchGroupNameList, setSearchGroupNameList] = useState([""]);
  async function getSaleCompanyGroupsList() {
    const fetchData = await getSerchSaleCompanyGroups();
    if (fetchData === null) {
      setSearchGroupList([]);
    } else if (fetchData) {
      setSearchGroupList(
        fetchData.saleCompanyGroups as {
          id: number;
          group_name: string;
          sale_company_id: number;
        }[],
      );
      let searchGroupNameList = [""];
      fetchData.saleCompanyGroups.map(
        (company: { id: number; group_name: string }) => {
          if (!searchGroupNameList.includes(company.group_name)) {
            searchGroupNameList.push(company.group_name);
          }
        },
      );
      setSearchGroupNameList(searchGroupNameList);
    }
  }
  // スタッフアカウント一覧
  const [accountSaleList, setAccountSaleList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountSaleNameList, setAccountSaleNameList] = useState([""]);
  async function getSaleAccountSalesList() {
    const fetchData = await getSerchAccountSales();
    if (fetchData === null) {
      setAccountSaleList([]);
    } else if (fetchData) {
      setAccountSaleList(
        fetchData.accountSales as { id: number; account_name: string }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountSales.map(
        (accountSale: { id: number; account_name: string }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountSaleNameList(accountSaleNameList);
    }
  }
  // 協業営業アカウント一覧
  const [
    accountCollaborateCompanySaleList,
    setAccountCollaborateCompanySaleList,
  ] = useState<
    {
      sale_company_id: number;
      sale_company_name: string;
      id: number;
      account_name: string;
    }[]
  >([]);
  const [
    accountCollaborateCompanySaleNameList,
    setAccountCollaborateCompanySaleNameList,
  ] = useState([""]);
  async function getCollaborateCompanySaleAccountSalesList() {
    const fetchData = await getSerchAccountCollaborateCompanys();
    if (fetchData === null) {
      setAccountCollaborateCompanySaleList([]);
    } else if (fetchData) {
      setAccountCollaborateCompanySaleList(
        fetchData.accountCollaborateCompanySales as {
          sale_company_id: number;
          sale_company_name: string;
          id: number;
          account_name: string;
        }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountCollaborateCompanySales.map(
        (accountSale: {
          sale_company_id: number;
          sale_company_name: string;
          id: number;
          account_name: string;
        }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountCollaborateCompanySaleNameList(accountSaleNameList);
    }
  }
  useEffect(() => {
    getCategoryList();
    getSaleCompanysList();
    getSaleCompanyGroupsList();
    getProductList();
    getProductNameLists();
    getSaleAccountSalesList();
    getCollaborateCompanySaleAccountSalesList();
  }, []);

  // 排他制御: 検索とAIチャットは同時に開かない
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      data-testid="tossup-page"
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
            ? "calc(100% - 331px)"
            : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      {(loginUser?.authority === "パートナー" ||
        loginUser?.authority === "営業アカウント") &&
      !serchOpen &&
      !aiChatOpen ? (
        <>
          <IconButton
            size="small"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="default"
            sx={{
              position: "fixed",
              bottom: "5px",
              right: "5px",
              zIndex: 1,
            }}
          >
            <CircleIcon
              fontSize="large"
              sx={{
                color: "white",
                width: "65px",
                height: "65px",
              }}
            />
          </IconButton>
          <IconButton
            data-testid="tossup-fab-add"
            size="small"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="default"
            onClick={() => setAddDataName("トスアップ")}
            sx={{
              position: "fixed",
              bottom: "5px",
              right: "5px",
              zIndex: 1,
            }}
          >
            <AddCircleIcon
              fontSize="large"
              sx={{
                color: "primary.dark",
                width: "65px",
                height: "65px",
              }}
            />
          </IconButton>
        </>
      ) : null}
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={columnSetting.status !== "none"}
        openColumnSettingWindow={openColumnSettingWindow}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={tossUpTableColumn}
              dataColumn={tossUpScreenColumn}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubTableDetail={() => {}}
              setGetSubTableAdd={() => {}}
              setGetSubTableEditDirect={setEditDataCustomerInfo}
              getSubSubTableName={{
                name: "",
                key: {},
                subData: [],
              }}
              setGetSubSubTableName={() => {}}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={() => {}}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={tossUpTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={() => {}}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={tossUpTableColumn}
            dataColumn={tossUpScreenColumn}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={searchGroupNameList}
            highRankCompanyNameList={[]}
            categoryNameList={categoryNameList}
            productNameList={productNameListCloser}
            productCandidateMap={{ product_name_list: productNameListTossUp, closer_product_name: productNameListCloser }}
            accountSaleNameList={accountSaleNameList}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="TossUp"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={tossUpTableColumn.detailTitle}
        editAuth={tossUpTableColumn.editAuth}
        dataColumn={tossUpScreenColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={dataDetailOption}
        dataDetailOptionSelect={[]}
        dataDetailHistory={dataDetailHistory}
        selectHistory={selectHistory}
        getOldDataDetail={getOldDataDetail}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={setSelectTossUpInfo}
      />
      <ChangeAccountCollaborateModal
        onModal={addData.addStatus === "change_account"}
        swCloseModal={() => {
          closeAddModal();
          setAddDataName("");
        }}
        changeAccount={addData.changeAccount}
        changeAccountID={addData.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setAddData({
            ...addData,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setAddData({
            ...addData,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"トスアップ"}
        getFormFunction={getTossUpProductList}
        accountColumn={"トスアップアカウント"}
      />
      <TossUpAddModal
        onModal={
          addData.addStatus !== null &&
          addData.addStatus !== "loading" &&
          addData.addStatus !== "change_account"
        }
        swCloseModal={() => {
          closeAddModal();
          setAddDataName("");
        }}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        uniqueOptinList={uniqueOptinList}
        setUniqueOptinList={setUniqueOptinList}
        addressOptionName={addressOptionName}
        setAddressOptionName={setAddressOptionName}
        postPictures={postPictures}
        setPostPicture={setPostPicture}
        tossUpCategoryNameList={tossUpCategoryNameList}
        tossUpProductNameList={tossUpProductNameList}
        setOnDataAddModalResult={setOnDataAddModalResult}
      />
      <ChangeAccountCollaborateModal
        onModal={closingData.addStatus === "change_account"}
        swCloseModal={() => closeClosingModal()}
        changeAccount={closingData.changeAccount}
        changeAccountID={closingData.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setClosingData({
            ...closingData,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setClosingData({
            ...closingData,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"クロージング"}
        getFormFunction={startClosing}
        accountColumn={"クロージングアカウント"}
      />
      <ClosingTossUpModal
        onModal={
          closingData.addStatus !== null &&
          closingData.addStatus !== "loading" &&
          closingData.addStatus !== "change_account"
        }
        swCloseModal={() => closeClosingModal()}
        cancellCloseModal={() => cancellClosingModal()}
        postAddData={closeingTossUpData}
        addData={closingData}
        setAddData={setClosingData}
        contractProductList={closingProductList}
        selectServisePlanList={selectServisePlanList}
        setSelectServisePlanList={setSelectServisePlanList}
        selectServiseContentList={selectServiseContentList}
        setSelectServiseContentList={setSelectServiseContentList}
        selectServiseCampaignPulldownList={selectServiseCampaignPulldownList}
        setSelectServiseCampaignPulldownList={
          setSelectServiseCampaignPulldownList
        }
        selectServiseCampaignCheckboxList={selectServiseCampaignCheckboxList}
        setSelectServiseCampaignCheckboxList={
          setSelectServiseCampaignCheckboxList
        }
        selectServisePaymentList={selectServisePaymentList}
        setSelectServisePaymentList={setSelectServisePaymentList}
        uniqueOptinList={closingUniqueOptinList}
        setUniqueOptinList={setClosingUniqueOptinList}
        addressOptionName={closingAddressOptionName}
        setAddressOptionName={setClosingAddressOptionName}
        postPictures={closingPostPictures}
        setPostPicture={setClosingPostPicture}
        putClosingFailed={putClosingFailed}
        copyClosingTossUp={copyClosingTossUp}
        setOnDataAddModalResult={setOnDataClosingModalResult}
        editAuth={tossUpTableColumn.editAuth}
        dataColumn={tossUpScreenColumn}
        dataDetail={dataDetailClosing}
        dataDetailOption={dataDetailOptionClosing}
      />
      <DataAddModalResult
        onModal={onDataClosingModalResult !== ""}
        swCloseModal={() => {
          setOnDataClosingModalResult("");
        }}
        addModalTitle={"クロージング"}
        onDataAddModalResult={onDataClosingModalResult}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => {
          setEditData(null);
          setSelectTossUpInfo({
            tossUpCategoryNameList: [],
            tossUpProductNameList: [],
          });
        }}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={selectTossUpInfo}
      />
      <DataEditModal
        onModal={
          editDataCustomerInfo !== null &&
          editDataCustomerInfo.status !== "editing"
        }
        swCloseModal={() => setEditDataCustomerInfo(null)}
        editData={editDataCustomerInfo}
        setEditData={setEditDataCustomerInfo}
        putEditData={putEditSubtableDataDirectCustomerInfo}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataDeleteModal
        onModal={
          deleteDataInf.status !== null && deleteDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteDataInf}
        setDeleteDataInf={setDeleteDataInf}
        deleteData={deleteData}
        labels={{
          title: "トスアップ取消",
          confirmBody: (
            <Alert severity="error">
              トスアップ取消後、データは復元できません。
              <br />
              誤って登録をしたトスアップのみ取消を実施してください。
            </Alert>
          ),
          confirmButtonLabel: "トスアップ取消",
          successMessage: "トスアップの削除に成功しました。",
        }}
      />
      <DataDeleteModal
        onModal={
          deleteTossUpInfoDataInf.status !== null &&
          deleteTossUpInfoDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteTossUpInfoDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({ name: "", key: {} });
        }}
        deleteDataInf={deleteTossUpInfoDataInf}
        setDeleteDataInf={setDeleteTossUpInfoDataInf}
        deleteData={deleteTossUpInfoData}
        labels={{
          title: "トスアップ情報項目の削除",
          confirmBody: (
            <Alert severity="error">
              項目「{deleteTossUpInfoDataInf.key.infoKey}」を削除します。削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "削除",
          successMessage: "トスアップ情報項目の削除に成功しました。",
        }}
      />
      <ChangeAccountCollaborateModal
        onModal={copyDataInf.addStatus === "change_account"}
        swCloseModal={() => {
          closeCopyDataModal();
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        changeAccount={copyDataInf.changeAccount}
        changeAccountID={copyDataInf.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setCopyDataInf({
            ...copyDataInf,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setCopyDataInf({
            ...copyDataInf,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"トスアップ複製"}
        getFormFunction={openCopyData}
        accountColumn={"トスアップアカウント"}
      />
      <ContractCopyTossUpModal
        onModal={
          copyDataInf.addStatus !== null &&
          copyDataInf.addStatus !== "loading" &&
          copyDataInf.addStatus !== "change_account"
        }
        swCloseModal={() => {
          closeCopyDataModal();
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        postAddData={postCopyDataData}
        addData={copyDataInf}
        setAddData={setCopyDataInf}
        uniqueOptinList={copyDataUniqueOptinList}
        setUniqueOptinList={setCopyDataUniqueOptinList}
        addressOptionName={copyDataAddressOptionName}
        setAddressOptionName={setCopyDataAddressOptionName}
        postPictures={copyDataPostPictures}
        setPostPicture={setCopyDataPostPicture}
        tossUpCategoryNameList={tossUpCategoryNameList}
        tossUpProductNameList={tossUpProductNameList}
        setOnDataAddModalResult={setOnDataAddModalResult}
      />
      <PostCSVModal
        onModal={
          postTossUpCSVStatus.status !== "none" &&
          postTossUpCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostTossUpCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postTossUpCSVStatus}
        setPostCSVStatus={setPostTossUpCSVStatus}
        postCSVFunc={postTossUpCSV}
        postCSVTitle={"CSV一括トスアップ"}
        postCSVColumn={postCSVColumnTossUp}
        postCSVColumnResult={postCSVColumnTossUpResult}
        postCSVPath="tossUp"
        productList={[]}
        categoryList={categoryList}
      />
      <PostCSVModal
        onModal={
          postTossUpCSVAdminStatus.status !== "none" &&
          postTossUpCSVAdminStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostTossUpCSVAdminStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postTossUpCSVAdminStatus}
        setPostCSVStatus={setPostTossUpCSVAdminStatus}
        postCSVFunc={postTossUpCSVAdmin}
        postCSVTitle={"トスアップ一括CSV取込"}
        postCSVColumn={postCSVColumnTossUpAdmin}
        postCSVColumnResult={postCSVColumnTossUpResultAdmin}
        postCSVPath="tossUpAdmin"
        productList={[]}
        categoryList={categoryList}
      />
      <GetXLSXTossUpModal
        onModal={getXLSXStatus.status !== "none"}
        swCloseModal={() => {
          setGetXLSXStatus({
            status: "none",
            message: "",
            toss_up_state: [],
            all_toss_up_state: false,
            category_id_list: [],
            all_category: false,
            sale_company_id: null,
            sale_company_name: "",
            all_company: true,
            product_id: null,
            product_name: "",
            all_product: true,
            toss_up_start_year: lastYear.toString(),
            toss_up_start_month: lastMonth.toString(),
            toss_up_end_year: thisYear.toString(),
            toss_up_end_month: thisMonth.toString(),
            toss_up_all_year: false,
            closing_start_year: lastYear.toString(),
            closing_start_month: lastMonth.toString(),
            closing_end_year: thisYear.toString(),
            closing_end_month: thisMonth.toString(),
            closing_all_year: true,
            hope_call_start_year: lastYear.toString(),
            hope_call_start_month: lastMonth.toString(),
            hope_call_end_year: thisYear.toString(),
            hope_call_end_month: thisMonth.toString(),
            hope_call_all_year: true,
          });
          setGetXLSXDataName("");
        }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getTossUpsXLSX}
        firstYear={firstYear}
        thisYear={thisYear}
        thisMonth={thisMonth}
        lastYear={lastYear}
        lastMonth={lastMonth}
        companyList={companyList}
        productList={productList}
        categoryList={categoryList}
      />
      <ColumnSettingModal
        onModal={
          columnSetting.status !== "none" && columnSetting.status !== "loading"
        }
        swCloseModal={closeColumnSettingModal}
        columnSetting={columnSetting}
        setColumnSetting={setColumnSetting}
        putClumnSetting={putClumnSetting}
      />
    </Box>
  );
}

export default TossUp;
